import React, { useState } from 'react';

const Assessment = ({ questions }) => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [userAnswers, setUserAnswers] = useState({});
    const [result, setResult] = useState(null);

    // Handle answer selection
    const handleAnswerChange = (questionId, selectedAnswer) => {
        setUserAnswers({
            ...userAnswers,
            [questionId]: selectedAnswer
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        let score = 0;
        questions.forEach((question) => {
            const correctAnswer = question.answer;
            const userAnswer = userAnswers[question.id];
            if (userAnswer === correctAnswer) {
                score++;
            }
        });
        setResult(`You scored ${score} out of ${questions.length}`);
    };

    // Navigate to the next question
    const handleNextQuestion = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    // Navigate to the previous question
    const handlePreviousQuestion = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    // Get current question
    const currentQuestion = questions[currentQuestionIndex];

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Assessment</h1>

            {/* Submit button at the top */}
            <form onSubmit={handleSubmit} style={styles.form}>
                <div style={styles.topButtonContainer}>
                    {currentQuestionIndex === questions.length - 1 && (
                        <button type="submit" style={styles.submitButton}>
                            Submit
                        </button>
                    )}
                </div>

                <div style={styles.questionBox}>
                    <div style={styles.progressText}>
                        Question {currentQuestionIndex + 1} of {questions.length}
                    </div>
                    <h3 style={styles.questionText}>{currentQuestionIndex + 1}. {currentQuestion.description}</h3>
                    <div style={styles.options}>
                        {currentQuestion.options.split(',').map((option, index) => (
                            <label key={index} style={styles.optionLabel}>
                                <div onClick={() => handleAnswerChange(currentQuestion.id, option)}>


                                    <input
                                        type="radio"
                                        name={`question-${currentQuestion.id}`}
                                        value={option}
                                        checked={userAnswers[currentQuestion.id] === option}
                                        style={styles.radioButton}
                                    />
                                    {option}
                                </div>
                            </label>
                        ))}
                    </div>
                </div>

                <div style={styles.navigationButtons}>
                    {currentQuestionIndex > 0 && (
                        <button type="button" onClick={handlePreviousQuestion} style={styles.prevButton}>
                            Previous Question
                        </button>
                    )}
                    {currentQuestionIndex < questions.length - 1 && (
                        <button type="button" onClick={handleNextQuestion} style={styles.nextButton}>
                            Next Question
                        </button>
                    )}
                </div>
            </form>
            {result && <h2 style={styles.result}>{result}</h2>}
        </div>
    );
};

// Inline styles for the component
const styles = {
    progressText: {
        fontSize: "18px",
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: "10px",
        color: "#333",
    },
    container: {
        // maxWidth: '600px',
        margin: '0 auto',
        padding: '20px',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
    },
    title: {
        textAlign: 'center',
        color: '#333',
        fontSize: '2rem',
        marginBottom: '20px'
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        overflow: 'hidden'
    },
    topButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px'
    },
    questionBox: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '20px',
        boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
        textAlign: 'left'
    },
    questionText: {
        fontSize: '1.25rem',
        color: '#444',
        marginBottom: '10px'
    },
    options: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
    },
    optionLabel: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1rem',
        color: '#555',
        padding: '8px 0',
        cursor: 'pointer'
    },
    radioButton: {
        marginRight: '10px'
    },
    navigationButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '20px'
    },
    prevButton: {
        padding: '10px 20px',
        backgroundColor: '#6c757d',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '1rem',
        transition: 'background-color 0.3s ease',
        alignSelf: 'center'
    },
    nextButton: {
        padding: '10px 20px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '1rem',
        transition: 'background-color 0.3s ease',
        alignSelf: 'center'
    },
    submitButton: {
        padding: '10px 20px',
        backgroundColor: '#28a745',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '1rem',
        transition: 'background-color 0.3s ease',
        alignSelf: 'center'
    },
    result: {
        textAlign: 'center',
        fontSize: '1.5rem',
        color: '#28a745',
        marginTop: '20px'
    }
};

export default Assessment;
